import { render, staticRenderFns } from "./KeranjangView.vue?vue&type=template&id=2f41a7d4"
import script from "./KeranjangView.vue?vue&type=script&lang=js"
export * from "./KeranjangView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports